/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Toggle_Caption_LockInputs */

const en_shortcut_keys_name_toggle_caption_lock = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Caption_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle Caption Lock`)
};

const fr_shortcut_keys_name_toggle_caption_lock = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Caption_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer verrouillage des sous-titres`)
};

const de_shortcut_keys_name_toggle_caption_lock = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Caption_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel-Sperre ein-/ausschalten`)
};

const it_shortcut_keys_name_toggle_caption_lock = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Caption_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva blocco didascalia`)
};

const ru_shortcut_keys_name_toggle_caption_lock = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Caption_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить/Выключить блокировку субтитров`)
};

const es_shortcut_keys_name_toggle_caption_lock = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Caption_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar o desactivar el bloqueo de subtítulos`)
};

const zh_cn2_shortcut_keys_name_toggle_caption_lock = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Caption_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换字幕锁定`)
};

const ja_shortcut_keys_name_toggle_caption_lock = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Caption_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプションロックを切り替える`)
};

const hi_shortcut_keys_name_toggle_caption_lock = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Caption_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन लॉक टॉगल करें`)
};

const pt_pt2_shortcut_keys_name_toggle_caption_lock = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Caption_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar/Desativar Bloqueio de Legendas`)
};

/**
* | output |
* | --- |
* | "Toggle Caption Lock" |
*
* @param {Shortcut_Keys_Name_Toggle_Caption_LockInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_toggle_caption_lock = /** @type {((inputs?: Shortcut_Keys_Name_Toggle_Caption_LockInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Toggle_Caption_LockInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_toggle_caption_lock(inputs)
	if (locale === "de") return de_shortcut_keys_name_toggle_caption_lock(inputs)
	if (locale === "it") return it_shortcut_keys_name_toggle_caption_lock(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_toggle_caption_lock(inputs)
	if (locale === "es") return es_shortcut_keys_name_toggle_caption_lock(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_toggle_caption_lock(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_toggle_caption_lock(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_toggle_caption_lock(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_toggle_caption_lock(inputs)
	return en_shortcut_keys_name_toggle_caption_lock(inputs)
});